import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import Input from '../Input';
import { ItemListController } from '../ItemList';

var ComboboxInput = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ComboboxInput, _Component);

  function ComboboxInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "setInputNode", function (node) {
      _this.inputNode = node;
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      if (e.key === 'ArrowUp') {
        e.preventDefault();

        _this.itemList.moveHighlightedIndex(-1, {
          contain: false
        });
      }

      if (e.key === 'ArrowDown') {
        e.preventDefault();

        _this.itemList.moveHighlightedIndex(1, {
          contain: false
        });
      }

      if (e.key === 'Enter') {
        e.preventDefault();

        _this.itemList.selectHighlightedItem();
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }

      if (_this.props.onClose && e.key === 'Tab') {
        _this.props.onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentKeyDown", function (e) {
      if (_this.props.onClear && e.key === 'Escape') {
        _this.props.onClear();
      }
    });

    return _this;
  }

  var _proto = ComboboxInput.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(lastProps) {
    var _this2 = this;

    if (lastProps.value !== this.props.value) {
      // needs to be called after items have been sorted, there's probably a better way to fix this
      setTimeout(function () {
        _this2.itemList.setHighlightedIndex(0);
      });
    }
  };

  _proto.focus = function focus() {
    this.inputNode.focus();
  };

  _proto.blur = function blur() {
    this.inputNode.blur();
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        autoFocus = _this$props.autoFocus,
        defaultValue = _this$props.defaultValue,
        disabled = _this$props.disabled,
        innerRef = _this$props.innerRef,
        isOpen = _this$props.isOpen,
        isLoading = _this$props.isLoading,
        name = _this$props.name,
        onBlur = _this$props.onBlur,
        onChange = _this$props.onChange,
        onFocus = _this$props.onFocus,
        onClear = _this$props.onClear,
        onClose = _this$props.onClose,
        onKeyDown = _this$props.onKeyDown,
        onKeyUp = _this$props.onKeyUp,
        placeholder = _this$props.placeholder,
        readOnly = _this$props.readOnly,
        size = _this$props.size,
        type = _this$props.type,
        value = _this$props.value,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["autoFocus", "defaultValue", "disabled", "innerRef", "isOpen", "isLoading", "name", "onBlur", "onChange", "onFocus", "onClear", "onClose", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "size", "type", "value"]);

    return /*#__PURE__*/React.createElement(ItemListController, null, function (itemList) {
      var highlightedItemId = itemList.highlightedItemId,
          id = itemList.id;

      if (!_this3.itemList) {
        _this3.itemList = itemList;
      }

      return /*#__PURE__*/React.createElement(Input.InputBox, _extends({
        innerRef: innerRef,
        size: size,
        disabled: disabled,
        isLoading: isLoading,
        onClear: onClear
      }, restProps, {
        grow: 1
      }), /*#__PURE__*/React.createElement(Input.InputField, {
        innerRef: _this3.setInputNode,
        grow: 1,
        role: "combobox",
        autoComplete: "off",
        "aria-autocomplete": "list",
        "aria-controls": id,
        "aria-expanded": isOpen,
        "aria-activedescendant": highlightedItemId,
        autoFocus: autoFocus,
        type: type,
        name: name,
        disabled: disabled,
        readOnly: readOnly,
        placeholder: placeholder,
        defaultValue: defaultValue,
        value: value,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: _this3.handleKeyDown,
        onKeyUp: onKeyUp
      }));
    });
  };

  return ComboboxInput;
}(Component);

_defineProperty(ComboboxInput, "displayName", 'Combobox.Input');

export default ComboboxInput;